import * as React from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import { Autocomplete, Divider, Grid, Select, TextField, Toolbar } from "@mui/material";
import Box from "@mui/material/Box";
import * as Yup from "yup";
import { Formik } from "formik";
import AddIcon from "@mui/icons-material/Add";
import { fetchMasterUnit, fetchRubricCondition, fetchRubricType } from "../../actions/pickList";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as BtnX } from "../../assets/images/plus-circle-fill.svg";
import { getPortfolioList, getPortfolioDetail, getPortfolioDetailList } from "../../actions/portfolio";
import CarryScore from "../../reducers/CarryScore";
import PickListRubrics from "../../reducers/PickListRubrics";
import { fetchPlanning, updatePlanning } from "../../actions/planning";
import cssVariables from "../../theme/cssVariables";
import { makeStyles } from "@mui/styles";
import { ReactComponent as EditIcon } from "../../assets/images/edit.svg";
import DialogChangeDetail from "../../components/planning/DialogChangeDetail";
import planning from "../../services/planning.service";
import { useFormik } from 'formik';

const emails = ['username@gmail.com', 'user02@gmail.com'];

const useStyles = makeStyles({
    disabled: {
        '& div > input': {
            fontWeight: 300,
        },
        '& .Mui-disabled': {
            '-webkit-text-fill-color': '#AAAAAA !important',
            backgroundColor: "#F7F7F7"
        }
    },
    menuList: {
        padding: "6px 16px",
        cursor: "pointer",
        "&:hover": {
            "background-color": "rgba(0, 0, 0, 0.04)"
        },
        display: "flex", 
        alignItems: "center", 
        width: "100%"
    },
    btnX: {
        justifyContent: "flex-end !important",
        paddingRight: "0 !important",
        paddingLeft: "0 !important",
        minWidth: "unset !important",
        '&:hover': {
            backgroundColor: 'transparent !important'
        }
    },
    input: {
        '& div > input': {
            fontWeight: 300,
        }
    },
    fillBlack: {
        '& > path': {
            fill: '#404349'
        },
        '& g > path': {
            fill: '#404349'
        },
    },
    MuiAutocomplete: {
        '& div > .MuiOutlinedInput-root': {
            padding: "0px",
            backgroundColor: "#F5F5F5 !important",
            '& > input': {
                padding: "10px 10px 10px 15px !important",
            }
        },
        "& div > p.Mui-error": {
            position: "absolute",
            bottom: "-22px",
        }
    },
    TextField: {
        '& div > input': {
            padding: "10px 10px 10px 15px !important",
            fontSize: "18px",
            fontWeight: "300",
            font: "unset",
            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                "-webkit-appearance": "none",
                display: "none"
            }
        },
        "& > p.Mui-error": {
            position: "absolute",
            bottom: "-22px",
            whiteSpace: "nowrap"
        }
    },
    errorDis: {
        "&  > div > div ": {
            backgroundColor: "#F5F5F5 !important",
        }
    },
    btnDisabled: {
        '& .Mui-disabled': {
            color: "#FFFFFF !important",
            backgroundColor: "#BABABA !important",
            marginLeft: "16px",
            marginTop: "16px"
        }
    },
    btnNotDis: {
        marginLeft: "16px",
        marginTop: "16px"
    }
});

const styles = {
    optional: {
        color: "#AAAAAA",
        fontSize: "14px",
        lineHeight: "24px",
        fontWeight: 300,
    },

    menuList: {
        padding: "6px 16px",
        cursor: "pointer",
        "&:hover": {
            "background-color": "rgba(0, 0, 0, 0.04)"
        },
        display: "flex", 
        alignItems: "center", 
        width: "100%"
    },
    divider: {
        margin: "0px 22px 0 23px"
    },
    title: {
        paddingLeft: "30px",
        paddingRight: "22px",
        // minHeight: "79px",
        color: cssVariables.color.black
    },
    textDetailTitle: {
        paddingTop: "35px",
        paddingBottom: "25px",
        color: cssVariables.color.black
    },
    textDetail: {
        fontWeight: "300",
        color: cssVariables.color.black
    },
    textTitleScore: {
        fontWeight: "300",
        color: "#A3A3A3"
    },
    textScore: {
        fontWeight: "300",
        marginTop: "10px",
        marginBottom: "25px",
    },
    input: {
        marginTop: "10px",
        marginBottom: "25px",
    },
    note: {
        marginTop: "10px",
        marginBottom: "47px",
    },
    btnCancel: {
        width: "117px",
        height: "44px",
        border: "1px solid #DADADA",
        color: "#393939",
        borderRadius: "5px"
    },
    btnSubmit: {
        width: "117px",
        height: "44px",
        borderRadius: "5px"
    },
    mainFlex: {
        justifyContent: "flex-end"
    },
    childFlex: {
        maxWidth: "max-content",
        marginRight: "-53px",
    },
    mainForm: {
        paddingLeft: "75px",
        paddingRight: "75px",
    },
    iconBox: {
        width: "18px",
        height: "18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        marginRight: "9px"
    },
};

function PlanningAddDetail(props) {
    const [filteredRubricCondition, setFilteredRubricCondition] = React.useState([]);
    const [dataAdd, setDataAdd] = React.useState([]);
    const [update, setUpdate] = React.useState(true);
    const [editForm, setEdit] = React.useState(false);
    const [maxVL, setMax] = React.useState(0);
    const [componentData, setComponentData] = React.useState({
        rb_pa_evaluate_condition_id: "",
        rubricType: "",
        rubricCondition: "",
        worth: "",
        score: "",
        remark: "",
        quantity: "",
    });
    const dispatch = useDispatch();
    const { rubricCat, selectedValue, onClose, id, add, row } = props
    useEffect(() => {
        dispatch(fetchMasterUnit())
        getDataAdd()
    }, []);

    useEffect(() => {
        let allData = {
            rubricType: "",
            rubricCondition: row?.serial,
            worth: row?.worth,
            score: "",
            remark: row?.remark,
            quantity: row?.quantity,
        }
        for (let index = 0; index <= dataAdd.length - 1; index++) {
            if (dataAdd[index]?.rb_condition?.length > 0) {
                for (let id = 0; id <= dataAdd[index].rb_condition.length - 1; id++) {
                    if (dataAdd[index].rb_condition[id]?.serial === row?.serial) {
                        onRubricConditionChange("", dataAdd[index].rb_condition[id])
                        let lComponentData = { ...componentData };
                        setFilteredRubricCondition(dataAdd[index].rb_condition);
                        lComponentData.rb_pa_evaluate_condition_id = row?.evaluate_condition?.serial;
                        lComponentData.rubricType = dataAdd[index];
                        lComponentData.rubricCondition = dataAdd[index].rb_condition[id];
                        lComponentData.quantity = row.quantity;
                        lComponentData.remark = row.remark;
                        lComponentData.academic_unit = dataAdd[index].rb_condition[id]?.value?.academic_unit;
                        lComponentData.worth = dataAdd[index].rb_condition[id]?.value?.worth;
                        lComponentData.score = Number.isNaN(Number(lComponentData.quantity)) ? 0 : Number.isNaN(Number(lComponentData.worth)) ? 0 : Math.round((Number(lComponentData.quantity) * Number(lComponentData.worth)) * 100) / 100
                        setMax(dataAdd[index].rb_condition[id]?.value?.max_value)
                        setComponentData(lComponentData)
                    }
                }
            }
        }
        setUpdate(!update)
    }, [row, dataAdd]);

    let getDataAdd = () => {
        planning.getAdd(id).then(
            (response) => {
                setDataAdd(response.data);
            });
    }

    const handleClose = () => {
        onClose();
    };
    const formik = useFormik({
        initialValues: {
            rubricType: componentData.rubricType,
            rubricCondition: componentData.rubricCondition,
            worth: componentData.worth || 0,
            score: componentData.score || 0,
            remark: componentData.remark,
            quantity: componentData.quantity,
        },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            quantity: Yup.number().required(`กรุณาระบุข้อมูล ปริมาณงานแผน`).nullable().max(maxVL !== undefined && maxVL !== null && maxVL !== "" && maxVL > 0 ? componentData?.worth !== undefined && componentData?.worth !== null && componentData?.worth !== "" && componentData?.worth > 0 ? (maxVL / componentData?.worth) : 99999999999999999999999999999999999999999999 : 99999999999999999999999999999999999999999999, "ปริมาณงานที่ระบุไว้ไม่ถูกต้อง"),
            rubricType: Yup.string().required(`กรุณาระบุข้อมูล ประเภทการประเมิน`),
            rubricCondition: Yup.string().required(`กรุณาระบุข้อมูล รายละเอียดการประเมิน`)
        })
    });
    const onInputChange = (evt, data) => {

        // update component state
        let lComponentData = { ...componentData };
        const oDataSet = evt.target.dataset
        let vValue = evt.target.value
        if (data === "remark") {
            lComponentData.remark = vValue
            if (editForm === false) {
                setEdit(true)
            }
        } else if (data === "quantity") {
            lComponentData.quantity = vValue.replaceAll(/[^0-9]/g, '')
            formik.setFieldValue("quantity", vValue)
            lComponentData.score = Number.isNaN(Number(vValue)) ? 0 : Number.isNaN(Number(lComponentData.worth)) ? 0 : Math.round((Number(vValue) * Number(lComponentData.worth)) * 100) / 100
            if (editForm === false) {
                setEdit(true)
            }
        }
        setComponentData(lComponentData)
    }
    const onAddDetailPress = (evt) => {
        add({ ...componentData, serial: id })
        handleClose()
    }
    const onRubricTypeChange = (evt, value, reason) => {
        let lComponentData = { ...componentData };
        // set cascade rubric data list
        setFilteredRubricCondition(value.rb_condition);
        lComponentData.rubricType = value;
        lComponentData.rubricCondition = null;
        lComponentData.academic_unit = "-";
        lComponentData.worth = 0;
        lComponentData.score = 0;
        setMax(0)
        setComponentData(lComponentData)
    }
    const onRubricConditionChange = (evt, value, reason) => {
        let lComponentData = { ...componentData };
        lComponentData.rubricCondition = value;
        lComponentData.academic_unit = value?.value?.academic_unit;
        lComponentData.worth = value?.value?.worth;
        lComponentData.score = Number.isNaN(Number(lComponentData.quantity)) ? 0 : Number.isNaN(Number(lComponentData.worth)) ? 0 : Math.round((Number(lComponentData.quantity) * Number(lComponentData.worth)) * 100) / 100
        setMax(value?.value?.max_value)
        setComponentData(lComponentData)
        // set cascade rubric
    }
    const { t } = useTranslation()
    const classes = useStyles()
    let sumMaxs = (maxVL, score) => {
        let sumMax = (maxVL / score)
        return sumMax
    }
    return (
        <Grid lg={12} md={12} m={0} p={0}>
            <Toolbar style={styles.title}>
                <Typography variant="h4" fontSize={24} lineHeight="26.4px">
                    {t('planning.label.editEvalDetail') + " "}
                    ({rubricCat?.description})
                </Typography>
                <Box sx={{ flex: 1 }} />
                <Box sx={{ position: "absolute", right: 0, margin: "18px 18px 0  0", top: 0, cursor: "pointer" }} onClick={handleClose}><BtnX /></Box>
            </Toolbar>
            <Divider style={styles.divider} />
            <Formik
                enableReinitialize
                initialValues={{
                    "rubricType": componentData.rubricType,
                    "rubricCondition": componentData.rubricCondition,
                    "worth": componentData.worth || 0,
                    "score": componentData.score || 0,
                    "remark": componentData.remark,
                    "quantity": componentData.quantity,
                }}
                validationSchema={Yup.object().shape({
                    quantity: Yup.number().required(`กรุณาระบุข้อมูล ปริมาณงานแผน`).nullable().max(maxVL !== undefined && maxVL !== null && maxVL !== "" && maxVL > 0 ? componentData?.worth !== undefined && componentData?.worth !== null && componentData?.worth !== "" && componentData?.worth > 0 ? sumMaxs(maxVL, componentData?.worth) : 99999999999999999999999999999999999999999999 : 99999999999999999999999999999999999999999999, "ปริมาณงานที่ระบุไว้ไม่ถูกต้อง"),
                    // remark: Yup.string().required(),
                    rubricType: Yup.string().required(`กรุณาระบุข้อมูล ประเภทการประเมิน`),
                    rubricCondition: Yup.string().required(`กรุณาระบุข้อมูล รายละเอียดการประเมิน`)
                })}
                onSubmit={() => {
                    // navigate('/app/dashboard', {replace: true});
                    onAddDetailPress().then(() => {
                        handleClose();
                    });
                }}
            >
                {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    values
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid lg={12} md={12} m={0} pl={6} pr={6} pb={6} container direction={'column'} style={styles.mainForm}>
                            <Grid item classes={{ root: classes.error }}>
                                <Typography variant="h4" pt={4} pb={4} fontSize={20} lineHeight={1.1} style={styles.textDetailTitle}>
                                    {t('label.evalDetail')}
                                </Typography>
                                <Typography variant="label" style={styles.textDetail} fontSize={18} lineHeight={1.1}>
                                    <label style={{ display: "flex" }}>{t('label.evalType')}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></label>
                                </Typography>
                                <Autocomplete
                                    inputProps={{
                                        'data-rowIndex': "",
                                        'data-rowItemIndex': "",
                                    }}
                                    disableClearable
                                    classes={{ root: classes.MuiAutocomplete }}
                                    // onChange={onRubricTypeChange}
                                    onChange={(e, value) => {
                                        handleChange(e);
                                        onRubricTypeChange(e, value);
                                        // setFieldValue("rubricType", value?.id || "";
                                    }}
                                    disablePortal
                                    disabled
                                    options={dataAdd}
                                    value={componentData.rubricType}
                                    getOptionLabel={(dataAdd) => dataAdd?.rubric_type?.name}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            error={Boolean(touched.rubricType && errors.rubricType)}
                                            fullWidth
                                            classes={{ root: classes.input }}
                                            style={styles.input}
                                            helperText={touched.rubricType && errors.rubricType}
                                            name="rubricType"
                                            variant="outlined"
                                            placeholder={t('planning.msg.type')}
                                        />}
                                />
                                <Typography variant="label" style={styles.textDetail} fontSize={18} lineHeight={1.1}>
                                    <label style={{ display: "flex" }}>{t('label.evalDetail')}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></label>
                                </Typography>
                                <Autocomplete
                                    inputProps={{
                                        'data-rowIndex': "",
                                        'data-rowItemIndex': "",
                                    }}
                                    disableClearable
                                    classes={{ root: classes.MuiAutocomplete }}
                                    // onChange={onRubricConditionChange}
                                    onChange={(e, value) => {
                                        handleChange(e);
                                        onRubricConditionChange(e, value);
                                        // setFieldValue("rubricType", value?.id || "";
                                    }}
                                    disabled
                                    value={componentData.rubricCondition}
                                    disablePortal
                                    options={filteredRubricCondition}
                                    getOptionLabel={(filteredRubricCondition) => filteredRubricCondition?.name}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            error={Boolean(touched.rubricCondition && errors.rubricCondition)}
                                            fullWidth
                                            classes={{ root: classes.input }}
                                            style={styles.input}
                                            helperText={touched.rubricCondition && errors.rubricCondition}
                                            name="rubricCondition"
                                            variant="outlined"
                                            placeholder={t('planning.msg.detail')}
                                        />}
                                />
                                <Grid container item spacing={4}>
                                    <Grid item lg={3}>
                                        <Typography variant="label" style={styles.textDetail} fontSize={18} lineHeight={1.1}>
                                            <label style={{ display: "flex" }}>{t('label.amountOfWork')}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></label>
                                        </Typography>
                                        <TextField
                                            inputProps={{
                                                'data-fieldName': "amountOfWork",
                                                'data-rowItemIndex': "",
                                            }}
                                            error={Boolean(touched.quantity && errors.quantity)}
                                            fullWidth
                                            helperText={touched.quantity && errors.quantity}
                                            margin="normal"
                                            name="quantity"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                onInputChange(e, "quantity")
                                            }}
                                            placeholder={t('planning.msg.inputAmountOfWork')}
                                            value={componentData.quantity}
                                            variant="outlined"
                                            classes={{ root: classes.input, root: classes.TextField }}
                                            style={styles.input}
                                        />
                                    </Grid>
                                    <Grid item lg={3} sx={{ display: "inline-grid" }}>
                                        <Typography variant="label" style={styles.textTitleScore} fontSize={18} lineHeight={1.1}>
                                            <label>{t('label.unit')}</label>
                                        </Typography>
                                        <Typography variant="label" style={styles.textScore} fontSize={18} lineHeight={1.1}>
                                            <label style={{ display: "flex", color: cssVariables.color.black }}>
                                                {componentData?.academic_unit?.name !== undefined && componentData?.academic_unit?.name !== null && componentData?.academic_unit?.name !== "" ?
                                                    componentData?.academic_unit?.name : "-"
                                                }
                                            </label>
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={3} sx={{ display: "inline-grid" }}>
                                        <Typography variant="label" style={styles.textTitleScore} fontSize={18} lineHeight={1.1}>
                                            <label>{t('label.valueOfWork')}</label>
                                        </Typography>
                                        <Typography variant="label" style={styles.textScore} fontSize={18} lineHeight={1.1}>
                                            <label style={{ display: "flex", color: cssVariables.color.black }}>
                                                {componentData?.worth !== undefined && componentData?.worth !== null && componentData?.worth !== "" ?
                                                    componentData?.worth : "0"
                                                }
                                            </label>
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={3} sx={{ display: "inline-grid" }}>
                                        <Typography variant="label" style={styles.textTitleScore} fontSize={18} lineHeight={1.1}>
                                            <label>{t('label.scoreGiven')}</label>
                                        </Typography>
                                        <Typography variant="label" style={styles.textScore} fontSize={18} lineHeight={1.1}>
                                            <label style={{ display: "flex" }}>
                                                {componentData?.score !== undefined && componentData?.score !== null && componentData?.score !== "" ?
                                                    Number(componentData?.score).toFixed(2) : "0"
                                                }
                                            </label>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Typography variant="label" style={styles.textDetail} fontSize={18} lineHeight={1.1}>
                                    <label>{t('label.remark')}</label>
                                </Typography>
                                <TextField
                                    error={Boolean(touched.remark && errors.remark)}
                                    inputProps={{
                                        'data-fieldName': "remark",
                                        'data-rowItemIndex': "",
                                    }}
                                    fullWidth
                                    helperText={touched.remark && errors.remark}
                                    margin="normal"
                                    name="remark"
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                        handleChange(e);
                                        onInputChange(e, "remark")
                                    }}
                                    type="text"
                                    value={componentData.remark}
                                    variant="outlined"
                                    placeholder={t('planning.msg.note')}
                                    classes={{ root: classes.input, root: classes.TextField }}
                                    style={styles.note}
                                    multiline
                                    rows={4}
                                />
                            </Grid>
                            <Grid item container style={styles.mainFlex}>
                                <Grid lg={6} item />
                                <Grid lg={6} item container spacing={2} style={styles.childFlex}>
                                    <Grid item lg={6}>
                                        <Button
                                            style={styles.btnCancel}
                                            fullWidth
                                            size="large"
                                            variant="outlined"
                                            onClick={handleClose}
                                        >
                                            {t('label.cancel')}
                                        </Button>
                                    </Grid>
                                    <Grid item lg={6} class={editForm === false ? `${classes.btnDisabled}` : componentData?.rubricType !== undefined && componentData?.rubricCondition !== undefined && componentData?.quantity !== undefined && componentData?.rubricType !== null && componentData?.rubricCondition !== null && componentData?.quantity !== null && componentData?.rubricType !== "" && componentData?.rubricCondition !== "" && componentData?.quantity !== "" ? `${classes.btnNotDis}` : `${classes.btnDisabled}`}>
                                        <Button
                                            style={styles.btnSubmit}
                                            onClick={handleSubmit}
                                            color="primary"
                                            disabled={editForm === false ? true : componentData?.rubricType !== undefined && componentData?.rubricCondition !== undefined && componentData?.quantity !== undefined && componentData?.rubricType !== null && componentData?.rubricCondition !== null && componentData?.quantity !== null && componentData?.rubricType !== "" && componentData?.rubricCondition !== "" && componentData?.quantity !== "" ? false : true}
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                        >
                                            {t('label.save')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Formik>
        </Grid>
    );
}
function SimpleDialog(props) {
    const { onClose, selectedValue, open, rubricCat, row, onAdd, id } = props;
    const handleClose = () => {
        onClose();
    };
    const handleListItemClick = (value) => {
        onClose();
    };
    const addClick = (value) => {
        onAdd(value);
    };
    return (
        <Dialog onBackdropClick={() => {return false}} onClose={handleClose} open={open} maxWidth='md' fullWidth sx={{ '.MuiPaper-root': { "borderRadius": "10px", "maxWidth": "916px" } }}>
            <PlanningAddDetail rubricCat={rubricCat} id={id} onClose={handleListItemClick} row={row} add={addClick} />
        </Dialog>
    );
}
SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
export default function DialogChangeDetails(props) {
    const { rubricCat, row, add, id } = props;
    const { t } = useTranslation();
    const classes = useStyles()
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (value) => {
        setOpen(false);
    };
    const adds = (value) => {
        add(value, value?.rb_pa_evaluate_condition_id !== undefined && value?.rb_pa_evaluate_condition_id !== null && value?.rb_pa_evaluate_condition_id !== "" ? "edit" : "add")
    };
    return (
        <Box sx={{ width: "100%" }}>
            <Typography
                sx={styles.menuList}
                // <Typography startIcon={<AddIcon />} variant="toolbar"
                onClick={handleClickOpen}
            >
                <Box style={styles.iconBox}>
                    <EditIcon class={`${classes.fillBlack}`} />
                </Box>
                {t('label.edit')}
            </Typography>
            <SimpleDialog
                row={row}
                rubricCat={rubricCat}
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                onAdd={adds}
                id={id}
            />
        </Box>
    );
}
